import React, { useState } from 'react';
import dailyNotificationService from '../services/dailyNotificationService';

const NotificationTestButton = () => {
  const [isVisible, setIsVisible] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [result, setResult] = useState('');

  const testImmediateNotification = async () => {
    setIsLoading(true);
    setResult('');
    
    try {
      const success = await dailyNotificationService.showImmediateNotification();
      if (success) {
        setResult('✅ Test notification sent successfully!');
      } else {
        setResult('❌ Failed to send notification. Check permissions.');
      }
    } catch (error) {
      setResult(`❌ Error: ${error.message}`);
    } finally {
      setIsLoading(false);
      setTimeout(() => setResult(''), 3000);
    }
  };

  const checkPermission = () => {
    const status = dailyNotificationService.getPermissionStatus();
    setResult(`📋 Permission status: ${status}`);
    setTimeout(() => setResult(''), 3000);
  };

  // Only show in development
  if (process.env.NODE_ENV === 'production') {
    return null;
  }

  if (!isVisible) return null;

  return (
    <div className="fixed bottom-4 right-4 z-50 bg-white dark:bg-gray-800 rounded-lg shadow-lg p-3 border border-gray-200 dark:border-gray-700">
      <div className="flex items-center justify-between mb-2">
        <span className="text-xs font-medium text-gray-600 dark:text-gray-400">
          Notification Test (Dev Only)
        </span>
        <button
          type="button"
          onClick={() => setIsVisible(false)}
          className="text-gray-400 hover:text-gray-600 dark:text-gray-500 dark:hover:text-gray-300 transition-colors"
        >
          <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <line x1="18" y1="6" x2="6" y2="18" />
            <line x1="6" y1="6" x2="18" y2="18" />
          </svg>
        </button>
      </div>
      <div className="flex flex-col space-y-2">
        <button
          onClick={testImmediateNotification}
          disabled={isLoading}
          className="px-3 py-1 bg-blue-600 text-white text-xs rounded hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
        >
          {isLoading ? 'Sending...' : 'Test Now'}
        </button>
        <button
          onClick={checkPermission}
          className="px-3 py-1 bg-gray-600 text-white text-xs rounded hover:bg-gray-700 transition-colors"
        >
          Check Permission
        </button>
      </div>
      {result && (
        <div className="mt-2 text-xs p-2 bg-gray-100 dark:bg-gray-700 rounded">
          {result}
        </div>
      )}
    </div>
  );
};

export default NotificationTestButton;
